import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const SESSION_KEY = "diwali_offer_popup_shown";
const OFFER_QUERY = "diwali-offer";
const WHATSAPP_PHONE = "918447165274";
const WHATSAPP_MESSAGE =
  "Hi! I’m interested in the Diwali offer for a website on rent at ₹27/month.My domainname is <>.";

const getWhatsAppUrl = () => {
  const message = encodeURIComponent(WHATSAPP_MESSAGE);
  const isMobile =
    /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

  return isMobile
    ? `https://wa.me/${WHATSAPP_PHONE}?text=${message}`
    : `https://web.whatsapp.com/send?phone=${WHATSAPP_PHONE}&text=${message}`;
};

const FestiveOfferPopup: React.FC = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (new URLSearchParams(location.search).get(OFFER_QUERY) === "1") {
      setIsOpen(true);
      return;
    }

    if (sessionStorage.getItem(SESSION_KEY)) return;

    const delay = 15000 + Math.random() * 45000;
    const timer = window.setTimeout(() => {
      sessionStorage.setItem(SESSION_KEY, "true");
      setIsOpen(true);
    }, delay);

    return () => window.clearTimeout(timer);
  }, [location.search]);

  useEffect(() => {
    if (!isOpen) return;

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") setIsOpen(false);
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className="festive-offer__backdrop"
      onClick={() => setIsOpen(false)}
    >
      <section
        aria-labelledby="festive-offer-title"
        aria-modal="true"
        className="festive-offer"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
      >
        <button
          aria-label="Close festive offer"
          className="festive-offer__close"
          onClick={() => setIsOpen(false)}
          type="button"
        >
          ×
        </button>
        <div aria-hidden="true" className="festive-offer__diya">
          🪔
        </div>
        <p className="festive-offer__eyebrow">DIWALI FESTIVE OFFER</p>
        <h2 id="festive-offer-title">
          Bring your domain.
          <br />
          We’ll bring it to life.
        </h2>
        <p className="festive-offer__description">
          Get a website on rent for just
        </p>
        <p className="festive-offer__price">
          <span>₹</span>27<span className="festive-offer__per-month">/ month</span>
        </p>
        <div className="festive-offer__perks">
          <span>No website development charges</span>
          <span>₹250 one-time setup charge</span>
        </div>
        <a
          className="festive-offer__cta"
          href={getWhatsAppUrl()}
          onClick={() => setIsOpen(false)}
          rel="noopener noreferrer"
          target="_blank"
        >
          Claim your festive offer <span aria-hidden="true">→</span>
        </a>
        <p className="festive-offer__note">
          You bring the domain name. We’ll take care of the website.
        </p>
        <p className="festive-offer__validity">Offer valid till Diwali 2027</p>
      </section>
    </div>
  );
};

export default FestiveOfferPopup;
